import { Component, ElementRef, EventEmitter, inject, Output, ViewChild } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { CalculationModuleService } from '@core/services/calculation-module.service'

@Component({
  selector: 'app-import-cm-inputs',
  templateUrl: './import-cm-inputs.component.html',
  styleUrls: ['./import-cm-inputs.component.scss'],
  imports: [
    //Forms
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,

    // Material
    MatButtonModule,
    MatIconModule,
  ],
})
export class ImportCmInputsComponent {
  @Output() dataImported = new EventEmitter<any>()
  @ViewChild('hiddenInput') csvFileInput!: ElementRef
  calculationModuleService = inject(CalculationModuleService)

  csvFile: File | undefined

  importAndApply(event: Event) {
    const target = event.target as HTMLInputElement
    if (target.files && target.files.length > 0) {
      this.csvFile = target.files[0]
      const fileReader = new FileReader()
      fileReader.onload = () => {
        const inputsToImport = fileReader.result
        const dataArray = this._parseCsvData(inputsToImport as string)
        this.dataImported.emit(dataArray)
        this.csvFileInput.nativeElement.value = null
      }
      if (this.csvFile) {
        fileReader.readAsText(this.csvFile)
      }
    }
  }

  handleFileInput(event: Event) {
    const target = event.target as HTMLInputElement
    if (target.files && target.files.length > 0) {
      this.csvFile = target.files[0]

      // update field
      var element = document.getElementById('fakeFileInput') as HTMLInputElement | null
      if (element != null && this.csvFile) {
        element.value = this.csvFile.name
      }
    }
  }

  importInputs() {
    if (!this.csvFile) {
      return
    }

    const fileReader = new FileReader()
    fileReader.onload = () => {
      const inputsToImport = fileReader.result
      const dataArray = this._parseCsvData(inputsToImport as string)
      this.dataImported.emit(dataArray)
      this.csvFileInput.nativeElement.value = null
    }
    fileReader.readAsText(this.csvFile)
  }

  private _parseCsvData(csvText: string): any[] {
    const lines = csvText.split('\n')

    if (lines.length < 4) {
      return []
    }

    const dataArray: any[] = []

    // Start reading file after INPUT (cm marker)
    let inputRow = 3 // by default starting at line 3
    //@TODO: manage if no INPUT title at all
    for (let i = 0; i < lines.length; i++) {
      const row = lines[i].trim()
      if (row == '"INPUT"') {
        inputRow = i
        break
      }
    }

    const propertyNames = lines[inputRow + 1].split(';').map((name) => name.trim())

    for (let i = inputRow; i < lines.length; i++) {
      const row = lines[i].trim()

      if (row == '"OUTPUT"') {
        break
      }

      if (row === '') {
        continue
      }

      // Remove input line and store as 1/2/3 name/value/unit (before was indicator/value/unit)
      if (row === '"INPUT"') {
        const rowKey = lines[i + 1].trim()
        const valuesKey = rowKey.split(';').map((value) => value.trim())
        const keys = { '1': valuesKey[0], '2': valuesKey[1], '3': valuesKey[2] }
        dataArray.push(keys)
        // next line (with header) already managed, continue to first line with value
        i++
        continue
      }

      const values = row.split(';').map((value) => value.trim())
      const obj: any = {}

      for (let index = 0; index < propertyNames.length; index++) {
        let propertyName = propertyNames[index]
        let val = values[index] || null

        // just in case (comment to delete after testing)
        propertyName = propertyName.replace(/^"(.*)"$/, '$1')
        val = val ? val.replace(/^"(.*)"$/, '$1') : val

        obj[propertyName] = val
      }

      dataArray.push(obj)
    }
    return dataArray
  }
}
